import React from 'react';
import Redux from 'redux';
import { connect } from 'react-redux';

import {
    createConnectedRequestCoordinator,
    createRequestClient,
    NewProps,
    ClientAttributes,
    methods,
    serverURL,
} from '#request';

import { AppState } from '#store/types';
import { User } from '#store/atom/user/types';
import { setAuthAction } from '#actionCreators';
import {
    authUserSelector,
    authPendingSelector,
} from '#selectors';

import { AuthAPI, AuthContext } from '#components/general/Auth';

import Multiplexer from './Multiplexer';

interface State {
}
interface Params {
}
interface OwnProps {}

interface PropsFromState {
    user?: User;
    authPending: boolean;
}
interface PropsFromDispatch {
    setAuth: typeof setAuthAction;
}

type ReduxProps = OwnProps & PropsFromState & PropsFromDispatch;

const mapStateToProps = (state: AppState): PropsFromState => ({
    user: authUserSelector(state),
    authPending: authPendingSelector(state),
});
const mapDispatchToProps = (dispatch: Redux.Dispatch): PropsFromDispatch => ({
    setAuth: params => dispatch(setAuthAction(params)),
});

const requests: { [key: string]: ClientAttributes<ReduxProps, Params> } = {
    authRequest: {
        url: '/auth/',
        method: methods.GET,
        onMount: true,

        onSuccess: ({ response, props: { setAuth } }) => {
            const user = response as User;
            setAuth({ user, pending: false });
        },

        onFailure: ({ props: { setAuth } }) => {
            // Error is almost always caused in this API due to not being
            // authenticated.
            setAuth({ user: undefined, pending: false });
        },

        extras: {
            schemaName: 'user',
        },
    },
};

type Props = NewProps<ReduxProps, Params>;

/* Loads required info from server */
class App extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        props.setAuth({ pending: true, user: undefined });

        this.authAPI = {
            refresh: this.redoAuth,
        };
    }

    private authAPI: AuthAPI;

    private redoAuth = () => {
        const { requests: { authRequest } } = this.props;
        authRequest.do();
    }

    public render() {
        const {
            authPending,
            user,
        } = this.props;

        const notAuthenticated = !authPending && !user;
        if (notAuthenticated) {
            window.location.href = `${serverURL}/login/`;
            return null;
        }

        const pending = authPending; // || otherPendings
        return (
            <AuthContext.Provider value={this.authAPI}>
                <Multiplexer pending={pending} />
            </AuthContext.Provider>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(
    createConnectedRequestCoordinator<ReduxProps>()(
        createRequestClient(requests)(
            App,
        ),
    ),
);
